import React from "react";
import ReactDOM from "react-dom";
import FindSite from "widgets/Sites";

export function renderSiteWidget(
  root,
  {
    onSiteConnectClick = null,
    onTrialSitesChange = null,
    useBrowserLocation = false,
    canViewByCountry = false,
    recap_key = "",
    website_language = "",
    website_country = "",
    google_place_api_key = "",
    referral_comment_box_setting = false,
  } = {}
) {
  return ReactDOM.render(
    <FindSite
      {...{
        onSiteConnectClick,
        useBrowserLocation,
        canViewByCountry,
        onTrialSitesChange,
        recap_key,
        website_language,
        website_country,
        google_place_api_key,
        referral_comment_box_setting,
      }}
    />,
    document.getElementById(root)
  );
}
